<div
  *transloco="let transloco; prefix: 'uiKit'"
  class="'form-sm form-multiselect'"
  [class]="class()"
>
  @if (formControl) {
    <ng-select
      bindLabel="name"
      class="border-none"
      bindValue="id"
      [appendTo]="appendTo()"
      [searchable]="false"
      [formControl]="formControl"
      [placeholder]="placeholder()"
      [multiple]="true"
      [closeOnSelect]="false"
      [items]="filteredItems()"
      [ngClass]="{ 'all-selected': isAllSelected }"
      [virtualScroll]="virtualScroll()"
      [notFoundText]="transloco('placeholders.noResults')"
      (change)="onSelectChange($event)"
      (close)="closeSelect.emit(); clearSearch()"
    >
      @if (showSelectAll() || searchable()) {
        <ng-template ng-header-tmp>
          <div class="select-header d-flex align-items-center gap-2">
            @if (showSelectAll()) {
              <div
                [class.w-100]="!searchable()"
                (click)="selectAll()"
                (keyup.enter)="selectAll()"
                tabindex="0"
                role="button"
              >
                <div
                  class="select-all-wrapper d-flex align-items-center gap-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    [checked]="isAllSelected"
                    class="form-check-input m-0"
                    style="
                      width: 16px;
                      height: 16px;
                      min-width: 16px;
                      border-radius: 4px;
                      cursor: pointer;
                    "
                  />
                  @if (!searchable()) {
                    <span>
                      {{
                        isAllSelected
                          ? transloco('placeholders.unselectAll')
                          : transloco('placeholders.selectAll')
                      }}
                    </span>
                  }
                </div>
              </div>
            }
            @if (searchable()) {
              <div
                class="search-input-wrapper position-relative d-flex align-items-center"
              >
                <ui-keenicon
                  name="magnifier"
                  class="search-icon position-absolute text-muted"
                ></ui-keenicon>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [placeholder]="transloco('placeholders.search')"
                  [value]="searchTerm()"
                  (input)="onSearchInput($event)"
                  (keydown)="$event.stopPropagation()"
                />
              </div>
            }
          </div>
        </ng-template>
      }
      @if (hiddenSelected()) {
        <ng-template ng-multi-label-tmp let-items="items">
          @if (items.length > 0) {
            <div class="ng-value px-2 py-1">
              <span class="ng-value-label">
                {{ items.length }}
                {{ transloco('placeholders.itemsSelected') }}
              </span>
            </div>
          }
        </ng-template>
      }
      @if (!hiddenSelected()) {
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          @if (items.length <= 2) {
            @for (item of items | slice: 0 : 2; track item) {
              <div class="ng-value d-flex align-items-center gap-2 pl-2">
                @if (t()) {
                  {{ truncate(t()!($any(item).name)) }}
                } @else {
                  {{
                    isTransloco()
                      ? truncate($any(item).name | transloco)
                      : truncate($any(item).name)
                  }}
                }

                <div
                  class="text-white cursor-pointer mx-1 my-1"
                  (click)="removeItem($any(item).id)"
                  (keyup.enter)="removeItem($any(item).id)"
                  tabindex="0"
                  role="button"
                >
                  &times;
                </div>
              </div>
            }
          }
          @if (items.length > 2) {
            <div class="ng-value px-3 py-1">
              <span class="ng-value-label">
                {{ $any(items).length }}
                {{ transloco('placeholders.itemsSelected') }}
              </span>
            </div>
          }
        </ng-template>
      }
      <ng-template ng-option-tmp let-item="item" let-item$="item$">
        @if (customOptionTemplate()) {
          <ng-container
            [ngTemplateOutlet]="customOptionTemplate()!"
            [ngTemplateOutletContext]="{ $implicit: item, item$: item$ }"
          ></ng-container>
        } @else {
          <div class="d-flex align-items-center gap-2">
            <input
              type="checkbox"
              [checked]="item$.selected"
              class="form-check-input m-0"
              style="
                width: 16px;
                height: 16px;
                min-width: 16px;
                border-radius: 4px;
              "
            />
            <span
              [innerHTML]="
                t()
                  ? t()!($any(item).name)
                  : isTransloco()
                    ? ($any(item).name | transloco)
                    : $any(item).name
              "
            ></span>
          </div>
        }
      </ng-template>
    </ng-select>
  }
  @if (!formControl) {
    <ng-select
      bindLabel="name"
      class="border-none"
      bindValue="id"
      [appendTo]="appendTo()"
      [searchable]="false"
      [placeholder]="placeholder()"
      [ngModel]="value()"
      (ngModelChange)="onModelChange($event)"
      [multiple]="true"
      [closeOnSelect]="false"
      [items]="filteredItems()"
      [ngClass]="{ 'all-selected': isAllSelected }"
      (close)="clearSearch()"
      [virtualScroll]="virtualScroll()"
      [notFoundText]="transloco('placeholders.noResults')"
    >
      @if (showSelectAll() || searchable()) {
        <ng-template ng-header-tmp>
          <div class="select-header d-flex align-items-center gap-2">
            @if (showSelectAll()) {
              <div
                [class.w-100]="!searchable()"
                (click)="selectModelAll()"
                (keyup.enter)="selectModelAll()"
                tabindex="0"
                role="button"
              >
                <div
                  class="select-all-wrapper d-flex align-items-center gap-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    [checked]="isAllSelected"
                    class="form-check-input m-0"
                    style="
                      width: 16px;
                      height: 16px;
                      min-width: 16px;
                      border-radius: 4px;
                      cursor: pointer;
                    "
                  />
                  @if (!searchable()) {
                    <span>
                      {{
                        isAllSelected
                          ? transloco('placeholders.unselectAll')
                          : transloco('placeholders.selectAll')
                      }}
                    </span>
                  }
                </div>
              </div>
            }
            @if (searchable()) {
              <div
                class="search-input-wrapper position-relative d-flex align-items-center"
              >
                <ui-keenicon
                  name="magnifier"
                  class="search-icon position-absolute text-muted"
                ></ui-keenicon>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [placeholder]="transloco('placeholders.search')"
                  [value]="searchTerm()"
                  (input)="onSearchInput($event)"
                  (keydown)="$event.stopPropagation()"
                />
              </div>
            }
          </div>
        </ng-template>
      }
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        @if (items.length <= 2) {
          @for (item of items | slice: 0 : 2; track item) {
            <div class="ng-value d-flex align-items-center gap-2 pl-2">
              @if (t()) {
                {{ truncate(t()!($any(item).name)) }}
              } @else {
                {{
                  isTransloco()
                    ? truncate($any(item).name | transloco)
                    : truncate($any(item).name)
                }}
              }
              <div
                class="text-white cursor-pointer mx-1 my-1"
                (click)="removeModelItem($any(item).id)"
                (keyup.enter)="removeModelItem($any(item).id)"
                tabindex="0"
                role="button"
              >
                &times;
              </div>
            </div>
          }
        }
        @if (items.length > 2) {
          <div class="ng-value px-3 py-1">
            <span class="ng-value-label">
              {{ $any(items).length }}
              {{ transloco('placeholders.itemsSelected') }}
            </span>
          </div>
        }
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$">
        @if (customOptionTemplate()) {
          <ng-container
            [ngTemplateOutlet]="customOptionTemplate()!"
            [ngTemplateOutletContext]="{ $implicit: item, item$: item$ }"
          ></ng-container>
        } @else {
          <div class="d-flex align-items-center gap-2">
            <input
              type="checkbox"
              [checked]="item$.selected"
              class="form-check-input m-0"
              style="
                width: 16px;
                height: 16px;
                min-width: 16px;
                border-radius: 4px;
              "
            />
            <span
              [innerHTML]="
                t()
                  ? t()!($any(item).name)
                  : isTransloco()
                    ? ($any(item).name | transloco)
                    : $any(item).name
              "
            ></span>
          </div>
        }
      </ng-template>
    </ng-select>
  }
</div>
@if (formControl && !skipValidation() && control()!['touched']) {
  <ui-validation-form [control]="control()!"></ui-validation-form>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
@if (lockedMessage()) {
  <div
    class="form-text d-inline-flex align-items-center gap-2 text-field-locked"
  >
    <i class="bi bi-lock-fill"></i>
    <span>{{ lockedMessage() }}</span>
  </div>
}
